import { useDispatch, useSelector } from "react-redux";
import { selectAllAlertsSorted } from "../../store/alertSlice/alertSelectors";
import { Alert, Snackbar } from "@mui/material";
import { removeAlert } from "../../store/alertSlice/alertSlice";


const AlertsContainer = () => {
  const dispatch = useDispatch();
  const alertsList = useSelector(selectAllAlertsSorted);

  const onClose = (id) => () => {
    dispatch(removeAlert(id));
  }

  return (
    <>
      {
        alertsList.map((alert) => {
          return (
            <Snackbar
              key={alert.id}
              open
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              autoHideDuration={alert.severity === 'error' ? null : 7000}
              onClose={onClose(alert.id)}
            >
              <Alert
                onClose={onClose(alert.id)}
                severity={alert.severity}
                variant="filled"
                sx={{ width: '100%' }}
              >
                {alert.text}
              </Alert>
            </Snackbar>
          )
        })
      }
    </>
  )
}

export default AlertsContainer;